/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { NavHOC } from "./nav_hoc";
import { Main } from "Views/scaffolding/layouts/main";

type Props = React.PropsWithChildren<{}>;

function ErrorLayout(props: Props): JSX.Element {
  return (
    <React.Fragment>
      <NavHOC />
      <Main>
        <p>ERROR:</p>
        {props.children}
      </Main>
    </React.Fragment>
  );
}

const errorLayoutMemo = React.memo<Props>(ErrorLayout);
export { errorLayoutMemo as ErrorLayout };
